'use client'

import { FC } from 'react'
import Image from 'next/image'
import { Separator } from '@repo/ui/separator'
import AminoChainLogo from '../../../public/aminochain.svg'
import { cn } from '@repo/ui/utils'

interface LoginHeaderProps {
  variant: 'welcome' | 'verification'
  className?: string
}

const LoginHeader: FC<LoginHeaderProps> = ({ variant, className = '' }) => {
  const isWelcome = variant === 'welcome'

  const logoConfig = {
    welcome: { width: 54, height: 33, gap: 'gap-2' },
    verification: { width: 46, height: 28, gap: 'gap-[7px]' },
  }

  const textConfig = {
    welcome: { size: 'text-[28px]', margin: 'mt-3' },
    verification: { size: 'text-2xl', margin: '' },
  }

  const separatorConfig = {
    welcome: 'mt-6 sm:mt-12',
    verification: 'mt-6 sm:mt-10',
  }

  return (
    <section className={cn('flex flex-col justify-center items-center w-full mx-4', { className })}>
      {isWelcome && <p className="text-xl text-grey-800 font-semibold">Welcome to</p>}

      <div className={`flex ${logoConfig[variant].gap} ${textConfig[variant].margin}`}>
        <Image
          alt="AminoChain"
          src={AminoChainLogo}
          width={logoConfig[variant].width}
          height={logoConfig[variant].height}
        />
        <p className={textConfig[variant].size}>AminoChain</p>
      </div>

      {!isWelcome && <p className="mt-3 sm:mt-6 text-xl text-grey-800 font-medium">Verification Code</p>}

      <Separator className={separatorConfig[variant]} />
    </section>
  )
}

export default LoginHeader
